import Image from "next/image";
import LoginForm from "@/components/forms/login";
import { serverSideTranslations } from "next-i18next/serverSideTranslations";

const Login = () => (
  <div className="w-full mx-auto flex flex-col items-center justify-center h-screen px-4 sm-px-0">
    <div className="max-w-md w-full bg-white shadow-xl p-14 rounded-md">
      <Image
        src="/images/jetizy.png"
        width={287}
        height={97}
        alt="Jetizy"
        className="mb-16 mx-auto"
      />
      <LoginForm />
    </div>
  </div>
);

export async function getServerSideProps({ locale }: any) {
  return {
    props: { ...(await serverSideTranslations(locale, ["common"])) },
  };
}
export default Login;
